    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            shiftmodels: null,
            shiftmodelUpdated: null,
            shiftmodelCreated: null
        }
    }
    
    const state = getDefaultState()

    const getters = {
        shiftmodels: state => {
            return state.shiftmodels
        },
        shiftmodelUpdated: state => {
            return state.shiftmodelUpdated
        },
        shiftmodelCreated: state => {
            return state.shiftmodelCreated
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        shiftmodels: (state, payload) => {
            state.shiftmodels = payload
        },
        shiftmodelUpdated: (state, payload) => {
            state.shiftmodelUpdated = payload
        },
        shiftmodelCreated: (state, payload) => {
            state.shiftmodelCreated = payload
        },
    }

    const actions = {
       
        getShiftmodels: ({commit, dispatch}, payload) =>{
            commit('updating', true)
            axiosAuth.get('/shiftmodels/' + payload._id )
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    commit('shiftmodels', res.data)
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                    if(error.response){
                        if(error.response.status == 401) dispatch('logout')
                    }
                }
              )
        },

        postShiftmodel ({commit, dispatch}, payload) {
            commit('updating', true)
            commit('shiftmodelCreated', null)
            axiosAuth.post('/shiftmodels', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        commit('shiftmodelCreated', true)
                        dispatch('getCompany')
                    }
                )
                .catch(
                error => {
                    commit('shiftmodelCreated', false)
                    console.log(error)
                    commit('updating', false)
                }
                )
        },

        updateShiftmodel: ({commit, dispatch}, payload) => {
            commit('shiftmodelUpdated', null)
            commit('updating', true)
            axiosAuth.patch('/shiftmodels/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    commit('shiftmodelUpdated', true)
                    dispatch('getCompany')
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('shiftmodelUpdated', false)
                    commit('updating', false)
                }
            ) 
        }
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }